import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionAd from './components/DiscussionAd';
const POST_STREAM = 'flarum/forum/components/PostStream';
const TARGET_TAG_SLUG = 'ask-the-community';
const EXTRA_POSITIONS = new Set([4, 9]);
function closeDesktopDiscussionPane() {
  try {
    // Desktop only
    if (!window.matchMedia('(min-width: 992px)').matches) return;
    if (app.pane?.pinned) {
      app.pane.togglePinned();
    }
    app.pane?.hide();
  } catch (error) {
    // Fail soft
  }
}
function isTargetDiscussion(discussion) {
  try {
    if (!discussion) return false;
    const tags = discussion.tags?.() || [];
    return tags.some(tag => tag?.slug?.() === TARGET_TAG_SLUG);
  } catch (error) {
    return false;
  }
}
function postNumberFromStreamChild(child) {
  try {
    const raw = child?.attrs?.['data-number'];
    if (raw === undefined || raw === null) return null;
    const number = Number(raw);
    return Number.isFinite(number) ? number : null;
  } catch (error) {
    return null;
  }
}
function ensureAdSizingStyle() {
  if (document.getElementById('pinoytalks-discussion-ad-inline-sizes')) return;
  const style = document.createElement('style');
  style.id = 'pinoytalks-discussion-ad-inline-sizes';
  style.textContent = `
    .PinoyTalks_discussion_ads_unit { display: block; width: 320px; height: 100px; margin: 0 auto; }
    @media (min-width: 500px) { .PinoyTalks_discussion_ads_unit { width: 468px; height: 60px; } }
    @media (min-width: 800px) { .PinoyTalks_discussion_ads_unit { width: 728px; height: 90px; } }
  `;
  document.head.appendChild(style);
}
app.initializers.add('pinoytalks-discussion-ads', () => {
  ensureAdSizingStyle();
  extend(POST_STREAM, 'afterFirstPostItems', function (items) {
    try {
      if (!isTargetDiscussion(this.discussion)) return;
      items.add('pinoytalks-discussion-ad-after-1', m(DiscussionAd, {
        postNumber: 1
      }), -100);
    } catch (error) {
      // Fail soft.
    }
  });
  extend('flarum/forum/components/DiscussionPage', 'oncreate', function () {
    window.setTimeout(() => {
      closeDesktopDiscussionPane();
    }, 100);
  });
  extend('flarum/forum/components/DiscussionPage', 'onupdate', function () {
    window.setTimeout(() => {
      closeDesktopDiscussionPane();
    }, 100);
  });
  extend(POST_STREAM, 'view', function (vnode) {
    try {
      if (!isTargetDiscussion(this.discussion)) return;
      if (!vnode || !Array.isArray(vnode.children)) return;
      const output = [];
      vnode.children.forEach(child => {
        output.push(child);
        const postNumber = postNumberFromStreamChild(child);
        if (!EXTRA_POSITIONS.has(postNumber)) return;
        output.push(m("div", {
          className: "PinoyTalksDiscussionAdRow",
          key: `pinoytalks-discussion-ad-row-after-${postNumber}`,
          "data-pinoytalks-ad-row-after-post": postNumber
        }, m(DiscussionAd, {
          postNumber: postNumber
        })));
      });
      vnode.children = output;
    } catch (error) {
      // Fail soft. Keep the original stream usable.
    }
  });
});